import { cn } from '@listening/utils/react-helpers';
import { formatTimeSeconds } from '@listening/utils/ts-utils';
import { Slider } from '@listening/frontend/components/radix/slider';
import { useHotkey } from '@tanstack/react-hotkeys';
import { useRef } from 'react';
import type { AudioChunkSeekBarHandle } from '@/lib/audio-chunk-player';
import { AudioChunkSeekBar } from '@/lib/audio-chunk-player';

export function SeekBar({
  className,
  timestampClassName = 'w-[58px] shrink-0 text-center font-mono text-[10px] whitespace-nowrap text-[var(--v2-text-muted)] tabular-nums sm:w-[68px] sm:text-[11px]',
  // The inline layouts wedge the track between controls, so it stays a hairline
  // there; a dedicated seek row can afford a thicker one.
  trackClassName = 'h-0.5',
}: {
  timestampClassName?: string;
  trackClassName?: string;
  className?: string;
}) {
  const seekBarRef = useRef<AudioChunkSeekBarHandle>(null);

  useHotkey(
    'ArrowLeft',
    () => {
      seekBarRef.current?.seekRelative(-5);
    },
    { preventDefault: false },
  );
  useHotkey(
    'ArrowRight',
    () => {
      seekBarRef.current?.seekRelative(5);
    },
    { preventDefault: false },
  );

  return (
    <AudioChunkSeekBar
      ref={seekBarRef}
      SeekBarRenderer={({ max, min, onValueChanged, onValueCommit, value }) => (
        <>
          <p className={timestampClassName}>
            {formatTimeSeconds(value / 1000)}
          </p>
          <Slider
            className={cn(
              'mx-1 min-w-0 flex-1 basis-auto cursor-pointer sm:min-w-32',
              className,
            )}
            max={max}
            min={min}
            onValueChange={([val]) => {
              if (val === undefined) return;
              onValueChanged(val);
            }}
            onValueCommit={([val]) => {
              if (val === undefined) return;
              // analyticsService.trackLogPlaybackControlsInteraction({
              //   interaction: 'seek',
              // });
              onValueCommit(val);
            }}
            thumbClassName='invisible'
            trackClassName={trackClassName}
            value={[value]}
          />
          <p className={timestampClassName}>{formatTimeSeconds(max / 1000)}</p>
        </>
      )}
    />
  );
}
